import React, { useState } from 'react'
import * as S from './styled'
import { VscClose, VscThreeBars } from 'react-icons/vsc'
import Link from 'next/link'
import { useRouter } from 'next/router'
import CustodiaMark from '~/assets/custodia-mark.svg'
import { ColoredBorderWrapper } from '~/components/molecules/ColoredBorderWrapper'

const ROUTES: { title: string; href: string; external?: boolean }[] = [
  {
    title: 'Avit',
    href: '/avit',
  },
  {
    title: 'Press',
    href: '/press',
  },
  {
    title: 'About',
    href: '/about',
  },
]

export const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  return (
    <S.NavBar>
      <div>
        <Link href={'/'}>
          <S.Logo>
            <CustodiaMark />
            <span>Custodia</span>
          </S.Logo>
        </Link>
        <S.DesktopRightContent>
          <S.MenuButton
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={!!menuOpen}
            aria-label="Menu"
            aria-controls="nav-menu"
          >
            {menuOpen ? <VscClose size={25} /> : <VscThreeBars size={25} />}
          </S.MenuButton>
          <S.DesktopNavItems>
            {ROUTES.map((r) => (
              <NavItem key={r.href} href={r.href} title={r.title} />
            ))}
          </S.DesktopNavItems>
        </S.DesktopRightContent>
      </div>
      <S.MobileNavItems menuOpen={menuOpen} id={'nav-menu'}>
        {ROUTES.map((r) => (
          <NavItem key={r.href} href={r.href} title={r.title} />
        ))}
        <S.MobileMenuSpacer />
      </S.MobileNavItems>
    </S.NavBar>
  )
}

interface DesktopNavItemProps {
  href: string
  title: string
  external?: boolean
}

const NavItem = ({ href, title, external }: DesktopNavItemProps) => {
  const router = useRouter()
  const isCurrentRoute =
    !external &&
    (router.route === href ||
      // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
      (href === '/avit' && router.route.startsWith('/avit/')))

  const content = (
    <span>
      {isCurrentRoute ? (
        <ColoredBorderWrapper>
          <S.NavItemTitle isSelected={isCurrentRoute}>{title}</S.NavItemTitle>
        </ColoredBorderWrapper>
      ) : (
        <S.NavItemTitle isSelected={isCurrentRoute}>{title}</S.NavItemTitle>
      )}
    </span>
  )

  return (
    <li>
      {external ? (
        <a href={href}>{content}</a>
      ) : (
        <Link href={href}>{content}</Link>
      )}
    </li>
  )
}
